import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../surfaces/background'

export const TextSeparatorContainer = styled(Background)<CmsProps>`
  background-color: ${({ theme, backgroundColour }) =>
    backgroundColour ?? theme.palette.silver.main};

  p {
    color: ${({ textColour }) => textColour ?? '#000'};
  }
`
